import React, { useEffect, useState } from 'react'

import classNames from 'classnames';
import { symbolList } from '../config/config';
import defaultNftImg from "../assets/default-nft.gif";
import { fixMintNumber } from '../utils/uiUtils/minMint';

import '../scss/components/nftcard.scss';
import { capitalize } from 'lodash';


export default function NftCard({
  nft,
  action,
  actionType,
  className,
  ownNFT,
  handleCheck,
  checked,
  handleTransfer,
  isPack,
  handleUnboxing,
  hideButtons,
}) {
  const [price, setPrice] = useState("");
  const [priceSymbol, setpriceSymbol] = useState("SWAP.HIVE");
  const [error, setError] = useState("");

  const handleClick = () => {
    if (!price) {
      return setError("Please input price.");
    }
    setError("");
    action(price, priceSymbol);
  }

  const handleChange = (e) => {
    setPrice(e.target.value);
    if (!e.target.value) {
      setError('Please input price.');
    } else {
      setError("");
    }
  }

  useEffect(() => {
    if (nft.price) {
      setPrice(nft.price);
    }
    if (nft.priceSymbol) {
      setpriceSymbol(nft.priceSymbol);
    }
  }, [nft])

  const { name = '', img = '', schema = '' } = nft.properties || {};
  fixDescription(nft);
  const underscoredName = name.replace(/ /g, '_');
  const mint = actionType === "Buy" ? nft.nftId : nft._id;
  const mintNumber = fixMintNumber({ name, mint });

  return (
    <div className={classNames('card mb-2 nftcard card-nft', className)}>
      <div className="nft-image-wrap">
        {/* <a href={nft.properties?.img} target="_blank" rel="noreferrer" > */}
          <img
            className="card-img-top"
            src={nft.properties?.img ? `https://play.crypto-shots.com/nft-images/hive/${schema}/${underscoredName}.gif` : defaultNftImg}
            alt={`https://gateway.pinata.cloud/ipfs/${nft.properties.img}`}
            onClick={() => handleCheck ? handleCheck(actionType === "Buy" ? nft.nftId : nft._id, !checked) : null}
          />
        {/* </a> */}
      </div>
      <div className='checkbox'>
        <input type="checkbox" checked={checked} onChange={(e) => handleCheck ? handleCheck(actionType === "Buy" ? nft.nftId : nft._id, e.target.checked) : null} />
      </div>
      <div className="card-body">
        <div className="properties">
          {nft.properties && Object.keys(nft.properties)
            .map((prop) => prop !== "img" && <p className="card-text m-0" key={prop}>
              <b>{capitalize(prop)}:</b> &nbsp; {nft.properties[prop]}
            </p>)
          }
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="card-title mb-2 nft-owner">
              {actionType !== "Sell" && <>
                  <span style={{ fontSize: '14px' }}>SELLER: &nbsp;</span>
                  <a href={`https://peakd.com/@${nft.account}`} target="_blank" rel="noreferrer">
                    <sub>{nft.account}</sub>
                  </a>
                </>
              }
            </h4>
          <h5 className="card-title mb-1 mint-num-wrap" style={{ float: 'right' }}>
            <span className="item-mint-num">MINT:</span><br/>
            {mintNumber}<sub><sub>({mint})</sub></sub>
          </h5>
        </div>

        {!hideButtons && <div className="mt-3">
          {actionType === "Sell"
            ? <div className="d-flex">
                <div>
                  <input className="form-control form-control-sm" style={{ width: 100 }} placeholder='Input price...' onChange={handleChange} />
                </div>
                <div style={{ marginLeft: '5px' }}>
                  <select className="form-control form-control-sm" value={priceSymbol} onChange={(e) => setpriceSymbol(e.target.value)}>
                    {symbolList.map((sym, index) => <option value={sym} key={index}>{sym}</option>)}
                  </select>
                </div>
              </div>
            : <div className="price">{parseFloat(nft.price)} {nft.priceSymbol}</div>
          }

          <div className="buttons" style={actionType !== "Sell" ? { marginTop: '-40px', paddingRight: '60px' } : {}}>
            <button
              className="btn-login mt-3 float-right btn-primary"
              onClick={handleClick}
            >
              {ownNFT ? "Cancel" : actionType }
            </button>
            {(!ownNFT && actionType === "Sell") && <button className="btn-login mr-2 mt-3 float-right btn-primary" onClick={() => handleTransfer(nft._id)}>Transfer</button>}
            {isPack && <button className="mr-2 mt-3 float-left btn-success pad5" onClick={() => handleUnboxing(nft._id)}>UNBOX</button>}
          </div>

        </div>}
        {error && <span className="text-danger">{error}</span>}
      </div>
    </div>
  )
};


const FIXED_DESCRIPTIONS = {
  'FORCE FIELD, LEVEL-1': 'Shield against the 2nd level boss',
};

const fixDescription = (nft = {}) => {
  if (!nft.properties.description) {
    const nftName = nft.properties.name?.toUpperCase();
    nft.properties.description = FIXED_DESCRIPTIONS[nftName] || 'n/a';
  }
};
